import {EnlilTable} from "../EnlilTable";
import withNavigate from "../../util/useNavigate";
import withBreakpoint from "../../util/withBreakpoint";
import {CircularProgress, Typography} from "@mui/material";
import ReactJson from "react-json-view";
import React from "react";
import {withAppContext} from "../../util/withAppContext";
import EnlilAxios from "../../util/EnlilAxios";
import {V1DeveloperLogIDOCToArray} from "../../util/Payload";

class DeveloperLogTable extends EnlilTable {
    _payloadRequestId = 0;

    constructor(props) {
        super(props);
        this.state = {
            ...this.state,
            selectedUsid: null,
            eventPayloadJSON: null,
            eventPayloadLoading: false,
            eventPayloadError: null,
        };
    }

    onRowClick(params) {
        this.applet.getEnterpriseComponent().selectRecord(params.row.id);
        this.loadPayloadForSelection();
    }

    onRowDoubleClick(params) {
        // Same as highlight — payload shows in the below-table panel.
        this.onRowClick(params);
    }

    enterpriseComponentLoadCompleted(ec) {
        super.enterpriseComponentLoadCompleted(ec);
        if (ec === this.applet.getEnterpriseComponent() && ec.getRecordPointer() >= 0) {
            this.loadPayloadForSelection();
        }
    }

    enterpriseComponentInvalidated(ec) {
        this._payloadRequestId += 1;
        this.setState({
            selectedUsid: null,
            eventPayloadJSON: null,
            eventPayloadLoading: false,
            eventPayloadError: null,
        });
        super.enterpriseComponentInvalidated(ec);
    }

    loadPayloadForSelection = () => {
        const ec = this.applet.getEnterpriseComponent();
        const usid = ec.getAttributeValue("USID");
        if (!usid) {
            this.setState({
                selectedUsid: null,
                eventPayloadJSON: null,
                eventPayloadLoading: false,
                eventPayloadError: null,
            });
            return;
        }

        const existingPayload = ec.getAttributeValue("EventPayloadJSON");
        if (existingPayload) {
            this.setState({
                selectedUsid: usid,
                eventPayloadJSON: existingPayload,
                eventPayloadLoading: false,
                eventPayloadError: null,
            });
            return;
        }

        const requestId = ++this._payloadRequestId;
        this.setState({
            selectedUsid: usid,
            eventPayloadJSON: null,
            eventPayloadLoading: true,
            eventPayloadError: null,
        });

        EnlilAxios({
            method: "GET",
            url: "t2/v1/developer_logs",
            json: true,
            params: {
                USID: usid,
                Limit: 1,
                Offset: 0,
            },
        }).then(response => {
            if (requestId !== this._payloadRequestId) {
                return;
            }
            const mapped = V1DeveloperLogIDOCToArray(response.data);
            const row = mapped?.Results?.[0];
            const payload = row?.EventPayloadJSON || null;
            if (payload) {
                ec.setAttributeValue("EventPayloadJSON", payload, true, false);
                ec.setAttributeValue("EventPayload", row.EventPayload, true, false);
            }
            this.setState({
                eventPayloadJSON: payload,
                eventPayloadLoading: false,
                eventPayloadError: payload ? null : "No payload for this log entry.",
            });
        }).catch(() => {
            if (requestId !== this._payloadRequestId) {
                return;
            }
            this.setState({
                eventPayloadJSON: null,
                eventPayloadLoading: false,
                eventPayloadError: "Failed to load payload.",
            });
        });
    };

    componentDidMount() {
        super.componentDidMount();
    }

    componentWillUnmount() {
        this._payloadRequestId += 1;
        super.componentWillUnmount();
    }

    getCellRenderer(name) {
        return super.getCellRenderer(name);
    }

    handleMenuClick(identifier) {
        super.handleMenuClick(identifier);
    }

    renderPayloadPanel() {
        const {
            selectedUsid,
            eventPayloadJSON,
            eventPayloadLoading,
            eventPayloadError,
        } = this.state;

        if (!selectedUsid && !eventPayloadLoading) {
            return (
                <div style={{
                    marginTop: "16px",
                    padding: "16px",
                    border: "1px solid #EDEFF3",
                    borderRadius: "5px",
                    backgroundColor: "#FAFBFC",
                }}>
                    <Typography style={{fontSize: 14, color: "#6B7280"}}>
                        Select a log row to view its payload.
                    </Typography>
                </div>
            );
        }

        return (
            <div style={{
                marginTop: "16px",
                padding: "16px",
                border: "1px solid #EDEFF3",
                borderRadius: "5px",
                backgroundColor: "#FFFFFF",
                maxHeight: "480px",
                overflow: "auto",
            }}>
                <Typography style={{fontSize: 16, fontWeight: 500, color: "#1498D8", marginBottom: "12px"}}>
                    Event payload
                </Typography>
                {eventPayloadLoading ? (
                    <div style={{display: "flex", justifyContent: "center", padding: "40px"}}>
                        <CircularProgress size={28}/>
                    </div>
                ) : eventPayloadError ? (
                    <Typography style={{fontSize: 13, color: "#6B7280"}}>{eventPayloadError}</Typography>
                ) : (
                    <div style={{fontFamily: "Courier New", fontSize: "12px"}}>
                        <ReactJson
                            keySort={true}
                            src={eventPayloadJSON || {}}
                            collapseStringsAfterLength={175}
                            collapsed={2}
                        />
                    </div>
                )}
            </div>
        );
    }

    renderExtension() {
        return null;
    }

    render() {
        return (
            <div style={{display: "flex", flexDirection: "column", width: "100%"}}>
                {super.render()}
                {this.renderPayloadPanel()}
            </div>
        );
    }
}

export default withNavigate(withAppContext(withBreakpoint(DeveloperLogTable)));
